module.exports = __webpack_public_path__ + "media/images/lp_v6_arw-88739569c94700c1a4a48f12a53664c3.webp";